export default "__VITE_ASSET__CwBswOOT__"